import screen from "./screen";
import common from "./common";
import routePath from "./routePath";

export default {
  common,
  screen,
  routePath
};
